var AbstractPlayerView   = require("./AbstractPlayerView"),
    HyperLinkSupport     = require("enyo-ui/HyperLinkSupport"),
    IconButton           = require("app/ui/IconButton"),
    Layout               = require("./VideoViewLayout"),
    PlayPauseButton      = require("app/MediaPlayer/PlayPauseButton"),
    ViewContainerSupport = require("app/core/ViewContainerSupport"),
    get                  = require("object-path").get,
    icons                = require("app/theme/icons"),
    kind                 = require("enyo/kind"),
    onHyperlinkTap       = require("app/utils/onHyperlinkTap");

require("./VideoView.less");
require("app/theme/IconButton--transparent-light.less");
require("app/theme/IconButton--close.less");

module.exports = kind(/** @lends  app.MediaPlayer.VideoView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.VideoView",

    /**
     * @private
     */
    kind: AbstractPlayerView,

    /**
     * @private
     */
    mixins: [ViewContainerSupport],

    /**
     * @private
     */
    classes: "app-media-player-video-view",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     */
    isReusable: true,

    /**
     * @private
     */
    components: [{
        name:       "metadata",
        classes:    "app-media-player-video-view__metadata",
        components: [{
            name:    "title",
            classes: "app-media-player-video-view__metadata-title"
        }]
    }, {
        name:    "playPauseButton",
        kind:    PlayPauseButton,
        classes: "app-media-player-video-view__play-pause-button",
        theme:   "transparent-light"
    }, {
        name:    "expandButton",
        kind:    IconButton,
        mixins:  [HyperLinkSupport],
        classes: "app-media-player-video-view__expand-button",
        icon:    icons["app.MediaPlayer.VideoView.expandButton"],
        theme:   "transparent-light",
        ontap:   "onHyperlinkTap"
    }, {
        name:    "closeButton",
        kind:    IconButton,
        classes: "app-media-player-video-view__close-button",
        icon:    icons["app.MediaPlayer.VideoView.closeButton"],
        theme:   "transparent-light",
        ontap:   "closePlayer"
    }],

    /**
     * @protected
     */
    update: function() {
        var state                   = this.state || {},
            $watchingSessionService = this.app.$.watchingSessionService,
            $expandButton           = this.$.expandButton,
            $player                 = this.getPlayerTech();

        this.$.title.set("content", get(state, "media.meta.title", null) || "");

        this.$.playPauseButton.set("mediaItem", get(state, "media", null));

        $expandButton.set("href", get(state, "media.links.player", null));

        if ($player) {
            if (get(state, "media", false)
                && get(state, "asset", false)
                && get($watchingSessionService, "session", false)) {
                $player.set("state", state);
            }
            else {
                $player && $player.set("state", null);
            }
        }

        this.resize();
    },

    /**
     * Verify displayMode support
     *
     * @param    {string}   displayMode  The display mode
     * @returns  {boolean}  Whether the display mode is supported
     * @public
     */
    supportsDisplayMode: function(displayMode) {
        return ["maximized", "picture-in-picture", "minimized"].includes(displayMode);
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap,

    /**
     * Instruct the app to close the media player.
     *
     * @private
     */
    closePlayer: function() {
        this.app.$.mediaPlayerManager.deactivateMediaPlayer();
    }

});
